import React, { useState } from 'react';
import { supabase } from './supabaseClient';

const LoginPage = ({ onLoginSuccess, onGoToRegister }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    try {
      // GoTrue verifies the password server-side against a hash and owns the
      // resulting session. Nothing about the credential is ours to store.
      const { data, error: signInError } = await supabase.auth.signInWithPassword({ email, password });

      if (signInError) {
        const badCredentials =
          signInError.code === 'invalid_credentials' ||
          signInError.message === 'Invalid login credentials';
        setError(badCredentials ? 'Неверный email или пароль' : 'Ошибка при входе в систему');
      } else if (onLoginSuccess) {
        onLoginSuccess(data.session);
      }
    } catch (err) {
      console.error('Ошибка при входе:', err);
      setError('Ошибка при входе в систему');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: '400px', margin: '50px auto', padding: '20px', border: '1px solid #ccc', borderRadius: '8px' }}>
      <h2 style={{ textAlign: 'center' }}>Вход в систему</h2>

      <form onSubmit={handleLogin} style={{ display: 'flex', flexDirection: 'column', gap: '15px', marginTop: '20px' }}>
        <input
          type="email"
          placeholder="email@example.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          style={{ padding: '10px', fontSize: '16px' }}
        />
        <input
          type="password"
          placeholder="Введите пароль"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          style={{ padding: '10px', fontSize: '16px' }}
        />
        <button type="submit" disabled={isLoading} style={{ padding: '10px', fontSize: '16px', cursor: 'pointer' }}>
          {isLoading ? 'Проверка...' : 'Войти'}
        </button>
      </form>

      {error && <p style={{ color: 'red', textAlign: 'center', marginTop: '10px' }}>{error}</p>}

      <div style={{ textAlign: 'center', marginTop: '20px' }}>
        <span>Нет аккаунта? </span>
        <button
          style={{ background: 'none', border: 'none', color: 'blue', cursor: 'pointer', padding: 0 }}
          onClick={onGoToRegister}
        >
          Зарегистрироваться
        </button>
      </div>
    </div>
  );
};

export default LoginPage;
